import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";
import { initLucideIcons } from "./lucide-icons.js";

const TOOLTIP_ROOTS = ".property__booking, .property__booking-perks, .booking-page__content";

function initTooltips(root = document) {
  const elements =
    root instanceof Element && root.matches("[data-tooltip]")
      ? [root, ...root.querySelectorAll("[data-tooltip]")]
      : root.querySelectorAll("[data-tooltip]");

  elements.forEach((el) => {
    if (el._tippy) {
      return;
    }

    const placement = el.dataset.tooltipDirection || "top";
    const maxWidth = el.dataset.tooltipMaxWidth
      ? Number.parseInt(el.dataset.tooltipMaxWidth, 10)
      : 280;

    tippy(el, {
      content: el.dataset.tooltip,
      allowHTML: true,
      interactive: true,
      placement,
      offset: [0, 10],
      appendTo: document.body,
      theme: "ferienhausliebe",
      maxWidth,
    });
  });

  if (root instanceof Element) {
    initLucideIcons(root);
  }
}

function observeTooltips() {
  const roots = document.querySelectorAll(TOOLTIP_ROOTS);
  if (!roots.length) {
    initTooltips();
    return;
  }

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) {
          continue;
        }

        if (node.matches("[data-tooltip]") || node.querySelector("[data-tooltip]")) {
          initTooltips(node);
        } else if (node.querySelector("[data-lucide]")) {
          initLucideIcons(node);
        }
      }
    }
  });

  roots.forEach((root) => {
    observer.observe(root, { childList: true, subtree: true });
  });

  initTooltips();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", observeTooltips);
} else {
  observeTooltips();
}
